import * as React from "react";
const SvgLoaderMaskCards = (props) => /* @__PURE__ */ React.createElement("svg", { width: 680, height: 320, ...props }, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 400, x: 320 }), /* @__PURE__ */ React.createElement("rect", { width: 680, height: 40, y: 200 }));
export default SvgLoaderMaskCards;
